import React from 'react'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'

import DesktopBooking from '../DesktopBooking/DesktopBooking'
import MobileBooking from '../MobileBooking/MobileBooking'

import useWindowDimensions from '../../hooks/useWindowDimensions'
import { toggleAccommodationModal } from '../../redux/actions/toggleAccommodationModal'
import { getIsAccommodationModalOpen } from '../../redux/reducers/accommodationModal'

export const AccommodationModal = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(getIsAccommodationModalOpen)
  const { width } = useWindowDimensions()

  function toggleModal() {
    dispatch(toggleAccommodationModal())
  }

  const getModalDimensions = () => {
    let dimensions = {}
    if (width < 1024) {
      dimensions = {height: '100%', width: '100%'}
    } else if (width >= 1024 && width < 1280) {
      dimensions = {width: '90%'}
    } else {
      dimensions = {width: '75%'}
    }
    return dimensions
  }

  return (
    <Modal
      parentSelector={() =>
        document.getElementById('ylg-ms__listings-details')
      }
      isOpen={isOpen}
      onRequestClose={toggleModal}
      contentLabel="Available Dates"
      style={{
        overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999 },
        content: {
          ...getModalDimensions(),
          border: 'none',
          margin: 'auto',
          maxWidth: 1460,
          overflowX: 'hidden',
          overflowY: 'auto',
          padding: 0,
          zIndex: 9999,
        },
      }}
    >
      <DesktopBooking onClose={toggleModal} />
      <MobileBooking onClose={toggleModal} />
    </Modal>
  )
}

export default AccommodationModal
